import axios from "../api";
import { ajaxErrorHandler, objectToParam } from "../../libs/utils";

export async function getCateringOptions(eventId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `events/${eventId}/catering-options?${parameters}`
  );
  return data;
}

export async function getCateringOption(eventId, id) {
  const { data } = await axios.get(`events/${eventId}/catering-options/${id}`);
  return data;
}

export async function getCateringOptionPeriods(eventId, id) {
  const { data } = await axios.get(
    `events/${eventId}/catering-options/${id}/periods`
  );
  return data.data;
}

export async function createCateringOption(eventId, values) {
  const { data } = await axios.post(
    `events/${eventId}/catering-options`,
    values
  );
  return data;
}

export async function syncCateringPeriod(eventId, cateringId, periods) {
  try {
    const { data } = await axios.put(
      `events/${eventId}/catering-options/${cateringId}/periods`,
      periods
    );
    return data;
  } catch (e) {
    ajaxErrorHandler(e);
  }
}

export async function updateCateringOption(eventId, id, values) {
  const { data } = await axios.patch(
    `events/${eventId}/catering-options/${id}`,
    values
  );
  return data;
}

export async function deleteCateringOption(eventId, id) {
  const { data } = await axios.delete(
    `events/${eventId}/catering-options/${id}`
  );
  return data;
}

export async function getCateringCosts(registrationId) {
  const { data } = await axios.get(
    `/registrations/${registrationId}/catering-costs`
  );
  return data;
}
